// components/BreadcrumbNav.js
import React, { useEffect, useRef } from "react";
import { Breadcrumb } from "../../common/utils/antd-imports/AntdImports";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setBreadcrumbs } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { truncateDescriptionText } from "../utils/Utils";

const BreadcrumbNav = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  // Track previous path so logic never becomes "one step late"
  const prevPathRef = useRef(null);
  const breadcrumbs = useSelector((state) => state.breadcrumb);
  // Filter out repeated breadcrumb titles while preserving order
  const uniqueBreadcrumbs = breadcrumbs?.filter(
    (crumb, index, self) =>
      index ===
      self.findIndex((c) => c.path === crumb.path && c.title === crumb.title)
  );

  // Update breadcrumbs automatically when path changes

  useEffect(() => {
    const currentPath = location.pathname + location.search;

    // Ignore first render or duplicate triggers
    if (prevPathRef.current === currentPath) return;
    prevPathRef.current = currentPath;

    // Clone current crumbs
    let newCrumbs = [...uniqueBreadcrumbs];
    // Check if this path already exists
    const existingIndex = newCrumbs.findIndex(
      (crumb) => crumb.path === currentPath
    );

    if (existingIndex !== -1) {
      // Path exists → truncate
      newCrumbs = newCrumbs.slice(0, existingIndex + 1);
    } else {
    }

    // Remove dynamic ID-like crumbs
    newCrumbs = newCrumbs.filter(
      (crumb) => !/^[a-f0-9]{8,}$/i.test(crumb.path)
    );

    // Avoid unnecessary dispatch
    if (JSON.stringify(uniqueBreadcrumbs) !== JSON.stringify(newCrumbs)) {
      dispatch(setBreadcrumbs(newCrumbs));
    }
  }, [location.pathname]);

  const handleCrumbClick = (index, path, title) => {
    let newCrumbs = uniqueBreadcrumbs?.slice(0, index + 1);
    // Remove dynamic campaign detail crumbs (ID-like path)
    newCrumbs = newCrumbs.filter(
      (crumb) => !/^[a-f0-9]{8,}$/i?.test(crumb.path)
    );
    // if (title !== "Campaigns") {
    dispatch(setBreadcrumbs(newCrumbs));
    navigate(path);
    // }
  };

  return (
    <Breadcrumb
      items={
        uniqueBreadcrumbs &&
        uniqueBreadcrumbs?.map((crumb, index) => {
          const isLast = index === uniqueBreadcrumbs?.length - 1;

          return {
            key: index,
            title: isLast ? (
              <span
                style={{
                  fontSize: 16,
                  fontFamily: "Roboto",
                  fontWeight: 400,
                }}
              >
                {crumb?.title}
              </span>
            ) : (
              <span
                style={{
                  fontSize: 16,
                  fontFamily: "Roboto",
                  fontWeight: 400,
                  cursor: "pointer",
                  color: "#d2042d",
                }}
                onClick={() => handleCrumbClick(index, crumb.path, crumb.title)}
              >
                {truncateDescriptionText(crumb?.title)}
              </span>
            ),
          };
        })
      }
    />
  );
};

export default BreadcrumbNav;
